import { useMemo } from "react";
import { useIntl } from "react-intl";
import CustomSelect from "../CustomSelect";
import { PersonStatuses } from "~enums/personStatuses";

type Props = {
  className?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  defaultValue?: string;
  value?: string;
}

const SelectPersonStatus = ({ className, disabled, onChange, defaultValue, value }: Props) => {
  const { formatMessage } = useIntl();

  const options = useMemo(
    () => Object.values(PersonStatuses).map((value) => ({ value, label: formatMessage({ id: `personStatus.${value}` })})),
    [],
  );

  return (
    <CustomSelect
      style={{ minWidth: "130px" }}
      value={value}
      defaultValue={defaultValue}
      onChange={(value) => onChange?.(value as string)}
      options={options}
      placeholder={formatMessage({ id: "status" })}
      allowClear
      className={className}
      disabled={disabled}
    />
  );
}

export default SelectPersonStatus;
